import { z } from "zod";

/** Represents the enum public.locale_enum */
type LocaleEnum = "en-US" | "fr-FR" | "es-ES" | "de-DE" | "zh-CN" | "ja-JP" | "ru-RU" | "ro-RO";

export default LocaleEnum;

/** Zod schema for locale_enum */
export const localeEnum = z.enum([
  "en-US",
  "fr-FR",
  "es-ES",
  "de-DE",
  "zh-CN",
  "ja-JP",
  "ru-RU",
  "ro-RO",
]);
